import styled from 'styled-components';

const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.show ? '0' : '-100%'};
  width: 300px;
  height: 100vh;
  background: white;
  border-left: 2px solid black;
  transition: right 0.3s ease-in-out;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-family: "Pixelify Sans", sans-serif;
  z-index: 9;
`;

const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
  margin-bottom: 20px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  font-family: "Pixelify Sans", sans-serif;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  padding: 0;
`;

const CartItem = styled.div`
  border: 2px solid black;
  padding: 15px;
  margin: 10px 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ItemImage = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
  border: 1px solid black;
  top: -9px;
  position: relative;
`;

const RemoveItem = styled.button`
  font-family: "Pixelify Sans", sans-serif;
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;

const CartActions = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Button = styled.button`
  font-family: "Pixelify Sans", sans-serif;
  background: ${props => props.primary ? 'black' : 'white'};
  color: ${props => props.primary ? 'white' : 'black'};
  border: 2px solid black;
  padding: 0.5rem;
  cursor: pointer;
  width: 100%;
  &:hover {
    opacity: 0.8;
  }
`;

const EmptyCart = styled.div`
  text-align: center;
  margin-top: 50px;
  color: #666;
`;

const TotalAmount = styled.div`
  text-align: right;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 1.2em;
`;

const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  position: relative;
  left: -62px;
`;

const QuantityButton = styled.button`
  background: none;
  border: 1px solid black;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Pixelify Sans", sans-serif;
  
  &:hover {
    background: #f0f0f0;
  }
`;

const Quantity = styled.span`
  font-size: 14px;
  min-width: 20px;
  text-align: center;
`;

const Sidebar = ({ show, onClose, cartItems, onRemoveItem, onClearCart, onCheckout, onUpdateQuantity }) => {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const price = parseFloat(item.price.replace('$', ''));
      return total + (price * item.quantity);
    }, 0);
  };

  return (
    <SidebarContainer show={show}>
      <CloseButton onClick={onClose}>
        X
      </CloseButton>
      
      <h2>Your Cart</h2>

      {cartItems.length === 0 ? (
        <EmptyCart>Nothing in your cart...</EmptyCart>
      ) : (
        <ScrollableContent>
          {cartItems.map(item => (
            <CartItem key={item.id}>
              <RemoveItem onClick={() => onRemoveItem(item.id, item.type)}>
                X
              </RemoveItem>
              <ItemImage src={item.image} alt={item.name} />
                <div style={{ flex: 1 }}>
                  <div>{item.name} ({item?.type}) {item.quantity > 1 && <span>x{item.quantity}</span>}</div>
                  <div>{item.price}</div>
                  <QuantityControls>
                    <QuantityButton 
                      onClick={() => onUpdateQuantity(item.id, item.type, item.quantity - 1)}
                    >
                      -
                    </QuantityButton>
                    <Quantity>{item.quantity}</Quantity>
                    <QuantityButton 
                      onClick={() => onUpdateQuantity(item.id, item.type, item.quantity + 1)}
                    >
                      +
                    </QuantityButton>
                  </QuantityControls>
                </div>
            </CartItem>
          ))}
          
          <TotalAmount>
            Total: ${calculateTotal().toFixed(2)}
          </TotalAmount>

          <CartActions>
            <Button onClick={onClearCart}>Empty Cart</Button>
            <Button primary onClick={onCheckout}>Checkout</Button>
          </CartActions>
        </ScrollableContent>
      )}
    </SidebarContainer>
  );
};

export default Sidebar;